<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">New Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addNewOrderButton="true"
          :permissions="{
            add_permission: 'add_new_order'
          }"
          :openAddNewOrderModal="openAddNewOrderModal"
          :checkAlert="checkAlert"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td>{{ r.theOrderID }}</td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td class="ws-nowrap">
                  {{ r.full_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }}
                </td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="date-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding: 0px 5px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('process_new_order')"
                  style="padding: 0px 5px"
                >
                  <process-the-order
                    :processOrder="processOrder"
                    :r="r"
                    :checkAlert="checkAlert"
                    :updateData="updateData"
                    :calculateTotalAmount="calculateTotalAmount"
                    :loading="loading"
                    :getResults="getResults"
                    :clearProcessOrderData="clearProcessOrderData"
                    :theQuantity="theQuantity"
                    :itemTypes="itemTypes"
                    :defaultPriceData="defaultPriceData"
                    :warehouses="warehouses"
                  >
                  </process-the-order>
                </td>
                <td
                  v-if="$_has_perm('cancel_new_order')"
                  style="padding: 0px 5px"
                >
                  <a
                    @click="openCancelingOrderModal(r.order_id)"
                    style="color:#C62828"
                    tooltip="Cancel This Order"
                  ><i class="material-icons">cancel</i></a>
                </td>
                <td
                  v-if="$_has_perm('send_pending_answer_order')"
                  style="padding: 0px 10px 0px 5px"
                >
                  <a
                    @click="sendToPendingAnswer(r.order_id)"
                    style="color:#FF9966;"
                    tooltip="Send to pending answer"
                  >
                    <i
                      style="font-size: 24px"
                      class="fa fa-adn"
                    ></i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.theOrderID }} , <br />
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer ID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color:#01579B; display: inline-block; padding-left: 5px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <span
                    v-if="$_has_perm('process_new_order')"
                    style="float: left"
                  >
                    <process-the-order
                      :processOrder="processOrder"
                      :r="r"
                      :checkAlert="checkAlert"
                      :updateData="updateData"
                      :calculateTotalAmount="calculateTotalAmount"
                      :loading="loading"
                      :getResults="getResults"
                      :clearProcessOrderData="clearProcessOrderData"
                      :theQuantity="theQuantity"
                      :itemTypes="itemTypes"
                      :defaultPriceData="defaultPriceData"
                    ></process-the-order>
                  </span>
                  <a
                    v-if="$_has_perm('cancel_new_order')"
                    @click="openCancelingOrderModal(r.order_id)"
                    style="color:#C62828; float: left; padding-left: 3px"
                    tooltip="Cancel This Order"
                  ><i class="material-icons">cancel</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <add-new-order
            :addNewOrderModal="addNewOrderModal"
            :warehouses="warehouses"
            :closeAddNewOrderModal="closeAddNewOrderModal"
            :checkAlert="checkAlert"
            :checkURL="checkURL"
            :makeNewOrder="makeNewOrder"
            :deliveryTypes="deliveryTypes"
            :makeOrderData="makeOrderData"
            :customers="customers"
            :loading="loading"
          >
          </add-new-order>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <admin-cancel-order
            :closeCancelingOrderModal="closeCancelingOrderModal"
            :cancelOrderModal="cancelOrderModal"
            :cancelAlert="cancelAlert"
            :cancelData="cancelData"
            :cancelingOrder="cancelingOrder"
          ></admin-cancel-order>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import mobileDatatable from './mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import addNewOrder from './addNewOrder.vue'
import processTheOrder from './processTheOrder.vue'
import adminCancelOrder from './adminCancelOrder'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'add-new-order': addNewOrder,
    'process-the-order': processTheOrder,
    'mobile-datatable': mobileDatatable,
    'admin-cancel-order': adminCancelOrder
  },
  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?order=', '') !== null ||
        window.location.search.replace('?order=', '') !== ''
      ) {
        let value = window.location.search.replace('?order=', '')
        this.searchOneCol('order_id', value)
      }
    }
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()
    this.getItemType()
    this.getDefaultPrices()
    this.getWarehouses()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  watch: {
    $route() {
      if (this.queryParameter === true) {
        if (
          window.location.search.replace('?order=', '') !== null ||
          window.location.search.replace('?order=', '') !== ''
        ) {
          let value = window.location.search.replace('?order=', '')
          this.searchOneCol('order_id', value)
        }
      }
    },
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'theOrderID',
      },
      // {
      //   label: 'Branches',
      //   text: 'Branches',
      //   value: '3',
      //   sortable: false,
      //   searchable: false,
      //   name: 'branches'
      // },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'product_url',
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'product_name',
      },
      {
        label: 'Quantity',
        text: 'Quantity',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'quantity',
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'country',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: 'Date',
        text: 'Date',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'order_date',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      processOrderUrl: 'api/orders',
      makeNewOrderUrl: 'api/orders',
      url: 'api/new_order',
      orderDetailUrl: 'api/show_order_detail',
      getCustomerUrl: 'api/get-customer-to-select',
      getItemTypeUrl: 'api/get-item-type',
      cancelingOrderUrl: 'api/canceling_order_by_admin',
      getDefaultPriceUrl: 'api/default_price',
      qrCodeValues: [],
      rowIndex: '',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      alertValue: false,
      checkAlert: false,
      checkURL: false,
      addNewOrderModal: false,
      warehouses: [],
      deliveryTypes: [
        { text: 'Home Delivery', value: 'home delivery' },
        { text: 'Office Delivery', value: 'office delivery' },
      ],
      customers: [],
      itemTypeResult: [],
      itemTypes: [],
      makeOrderData: {
        customer_id_fk: '',
        warehouse_id_fk: '',
        product_name: '',
        product_url: '',
        quantity: '',
        delivery_type: '',
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        // c_o_d: "",
      },
      temp_shipping: '',
      cancelData: {
        cancel_reason: '',
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      updateData: {
        item_price: '',
        the_tl_price: '',
        tax: '',
        national_tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        delivery_price: '',
        kreenex_fee: '',
        quantity_charge: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        description: '',
        tmp_shipping: '',
        send_sms: false,
        discount: '',
        item_type: '',
      },
      detialData: {},
      priceValues: {
        item_price: 0,
        internal_shipping_handling: 0,
        tax: 0,
        delivery_price: 0,
        quantity_charge: 0,
        kreenex_fee: 0,
        insurance: 0,
        discount: 0,
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      customersResult: [],
      theQuantity: {
        quantity: '',
      },
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      defaultPriceData: {
        kreenex_fee_base_usa: '',
        kreenex_fee_base_turkey: '',
        kreenex_fee_turkey: '',
        kreenex_fee_usa: '',
        kreenex_fee_percentage: '',
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: '',
      },
    }
  },

  methods: {
    sendToPendingAnswer(orderId) {
      swal({
        title: 'Are you sure?',
        text: 'Send to Pending Answer',
        icon: 'warning',
        buttons: true
      }).then((confirmed) => {
        if (confirmed) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/pending_answer_order/${orderId}`, {}, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true
      this.theCancelOrderID = orderId
    },

    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelData.cancel_reason = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.cancelAlert = true
          let self = this
          setTimeout(() => {
            self.closeCancelingOrderModal()
          }, 1500)
        })
    },

    getDefaultPrices() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          this.defaultPriceData.kreenex_fee_base_usa = result[0].kreenex_fee_base_usa
          this.defaultPriceData.kreenex_fee_base_turkey = result[0].kreenex_fee_base_turkey
          this.defaultPriceData.kreenex_fee_turkey = result[0].kreenex_fee_turkey
          this.defaultPriceData.kreenex_fee_usa = result[0].kreenex_fee_usa
          this.defaultPriceData.kreenex_fee_percentage = result[0].kreenex_fee_percentage
        })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()

      let a = this
      setTimeout(function () {
        a.queryParameter = true
      }, 1000)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    makeNewOrder() {
      this.loading = true
      let token = localStorage.getItem('access_token')

      this.makeOrderData.delivery_type = 'office delivery'

      axios
        .post(this.makeNewOrderUrl, this.makeOrderData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.loading = false
          this.checkURL = false
          this.checkAlert = true
          let a = this
          setTimeout(function () {
            a.clearNewOrerData()
          }, 2000)
          this.getResults()
        })
        .catch((error) => {
          this.loading = false
          this.checkAlert = false
          if (error.response.data.message.product_url) {
            this.checkURL = true
          } else {
            this.checkURL = false
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    openAddNewOrderModal() {
      this.addNewOrderModal = true
    },

    closeAddNewOrderModal() {
      this.addNewOrderModal = false
      this.clearNewOrerData()
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customersResult = response.data.data
          this.customersResult.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    getItemType() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.itemTypeResult = response.data.data
          this.itemTypeResult.forEach((c) => {
            this.itemTypes.push({
              text: c.type_name,
              value: c.type_name,
              shippingPrice: c.type_int_shipping_price
            })
          })
        })
    },

    calculateTotalAmount() {
      let itemPrice = Number(this.updateData.item_price) || 0
      let shipping = Number(this.updateData.internal_shipping_handling) || 0
      let tax = Number(this.updateData.tax) || 0
      let nationalTax = Number(this.updateData.national_tax) || 0
      let delivery = Number(this.updateData.delivery_price) || 0
      let fee = Number(this.updateData.kreenex_fee) || 0
      let insurance = Number(this.updateData.insurance) || 0
      let qttCharge = Number(this.updateData.quantity_charge) || 0
      let discount = Number(this.updateData.discount) || 0
      let qtt = Number(this.theQuantity.quantity) || 0

      let total =
        itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge

      if (discount > 0) {
        total -= discount
      }

      this.updateData.total_amount = total.toFixed(2)
    },

    // calculateTotalAmountOld() {
    //   if (this.updateData.item_price !== '') {
    //     this.priceValues.item_price = this.updateData.item_price
    //   } else {
    //     this.priceValues.item_price = 0
    //   }
    //   if (this.updateData.internal_shipping_handling !== '') {
    //     this.priceValues.internal_shipping_handling = this.updateData.internal_shipping_handling
    //   } else {
    //     this.priceValues.internal_shipping_handling = 0
    //   }
    //   if (this.updateData.tax !== '') {
    //     this.priceValues.tax = this.updateData.tax
    //   } else {
    //     this.priceValues.tax = 0
    //   }
    //   if (this.updateData.delivery_price !== '') {
    //     this.priceValues.delivery_price = this.updateData.delivery_price
    //   } else {
    //     this.priceValues.delivery_price = 0
    //   }
    //   if (this.updateData.kreenex_fee !== '') {
    //     this.priceValues.kreenex_fee = this.updateData.kreenex_fee
    //   } else {
    //     this.priceValues.kreenex_fee = 0
    //   }
    //   if (this.updateData.insurance !== '') {
    //     this.priceValues.insurance = this.updateData.insurance
    //   } else {
    //     this.priceValues.insurance = 0
    //   }
    //   if (this.updateData.quantity_charge !== '') {
    //     this.priceValues.quantity_charge = this.updateData.quantity_charge
    //   } else {
    //     this.priceValues.quantity_charge = 0
    //   }
    //   if (this.updateData.discount !== '') {
    //     this.priceValues.discount = this.updateData.discount
    //   } else {
    //     this.priceValues.discount = 0
    //   }

    //   if (this.priceValues.discount === 0) {
    //     this.priceValues.item_price = Number(this.priceValues.item_price)
    //     this.theQuantity.quantity = Number(this.theQuantity.quantity)
    //     this.priceValues.internal_shipping_handling = Number(
    //       this.priceValues.internal_shipping_handling
    //     )
    //     this.priceValues.tax = Number(this.priceValues.tax)
    //     this.priceValues.delivery_price = Number(this.priceValues.delivery_price)
    //     this.priceValues.kreenex_fee = Number(this.priceValues.kreenex_fee)
    //     this.priceValues.insurance = Number(this.priceValues.insurance)
    //     this.priceValues.quantity_charge = Number(this.priceValues.quantity_charge)

    //     this.updateData.total_amount = (
    //       this.priceValues.item_price * this.theQuantity.quantity +
    //       this.priceValues.internal_shipping_handling +
    //       this.priceValues.tax * this.theQuantity.quantity +
    //       this.priceValues.delivery_price +
    //       this.priceValues.kreenex_fee +
    //       this.priceValues.insurance +
    //       this.priceValues.quantity_charge
    //     ).toFixed(2)
    //   } else {
    //     this.priceValues.item_price = Number(this.priceValues.item_price)
    //     this.theQuantity.quantity = Number(this.theQuantity.quantity)
    //     this.priceValues.internal_shipping_handling = Number(
    //       this.priceValues.internal_shipping_handling
    //     )
    //     this.priceValues.tax = Number(this.priceValues.tax)
    //     this.priceValues.delivery_price = Number(this.priceValues.delivery_price)
    //     this.priceValues.kreenex_fee = Number(this.priceValues.kreenex_fee)
    //     this.priceValues.insurance = Number(this.priceValues.insurance)
    //     this.priceValues.quantity_charge = Number(this.priceValues.quantity_charge)

    //     let tempTotal =
    //       this.priceValues.item_price * this.theQuantity.quantity +
    //       this.priceValues.internal_shipping_handling +
    //       this.priceValues.tax +
    //       this.priceValues.delivery_price +
    //       this.priceValues.kreenex_fee +
    //       this.priceValues.insurance +
    //       this.priceValues.quantity_charge

    //     let discountAmount = (tempTotal * this.priceValues.discount) / 100
    //     this.updateData.total_amount = tempTotal - discountAmount
    //     this.updateData.total_amount = this.updateData.total_amount.toFixed(2)
    //   }
    // },

    clearNewOrerData() {
      this.makeOrderData.warehouse_id_fk = ''
      this.makeOrderData.product_name = ''
      this.makeOrderData.product_url = ''
      this.makeOrderData.quantity = ''
      this.makeOrderData.note = ''
      this.makeOrderData.coupon = ''
      this.makeOrderData.size = ''
      this.makeOrderData.type = ''
      this.makeOrderData.color = ''
      this.makeOrderData.c_o_d = ''
      this.checkAlert = false
      this.checkURL = false
      this.loading = false
    },

    clearProcessOrderData() {
      this.updateData.item_price = ''
      this.updateData.the_tl_price = ''
      this.updateData.tax = ''
      this.updateData.item_weight = ''
      this.updateData.internal_shipping_handling = 0
      this.updateData.delivery_price = ''
      this.updateData.kreenex_fee = ''
      this.updateData.insurance = ''
      this.updateData.total_amount = ''
      this.updateData.from_date = ''
      this.updateData.to_date = ''
      this.updateData.quantity_charge = ''
      this.updateData.description = ''
      this.updateData.item_type = ''
      this.updateData.discount = ''
      this.updateData.send_sms = false

      this.priceValues.item_price = 0
      this.priceValues.internal_shipping_handling = 0
      this.priceValues.tax = 0
      this.priceValues.delivery_price = 0
      this.priceValues.kreenex_fee = 0
      this.priceValues.insurance = 0
      this.priceValues.quantity_charge = 0
      this.priceValues.discount = 0
      this.checkAlert = false
    },

    processOrder(event, id, stime, stime1, stime2) {
      let token = localStorage.getItem('access_token')
      this.loading = true
      this.updateData.send_sms = this.updateData.send_sms.toString()

      axios
        .put(this.processOrderUrl + '/' + id, this.updateData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.loading = false
          this.clearProcessOrderData()
          stime.time = ''
          stime1.time = ''
          stime2.time = ''
          this.checkAlert = true
          let b = this
          setTimeout(function () {
            b.getResults()
            b.checkAlert = false
          }, 1500)
        })
        .catch(() => {
          this.loading = false
          this.clearProcessOrderData()
          stime.time = ''
          stime1.time = ''
          stime2.time = ''
          this.checkAlert = true
          let b = this
          setTimeout(function () {
            b.getResults()
            b.checkAlert = false
          }, 1500)
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/newOrder.vue